module.exports = __webpack_public_path__ + "img/Outro_Background@2x.51febb49.jpg";